angular.module('bmsApp.sm', [
	'bmsApp.sm.quote',
	'bmsApp.sm.job',
	'bmsApp.sm.schedule',
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.sm', {
					abstract: true,
					url: '/sm'
				})

			;
		}]);
